const CN ={
    total_installs_price: '平均每次转化费用（总计）',
    search_field_placeholder: '请输入搜索词，多个用逗号隔开',
    search_field_valid_1: '请输入搜索词',
    search_field_valid_2: '不可输入[]\\;{}"<>与表情',
    comparison_type_valid: '运算符必填',
    metric_monitoring: '智能托管',
    greater_than_or_equal_to: '大于等于',
    less_than_or_equal_to: '小于等于',
    rmb: '人民币',
    usd: '美元',
    trigger_condition: '触发条件',
    comparison_value_placeholder: '请输入正数',
    comparison_value_valid_1: '请输入正数，最多两位小数',
    comparison_value_valid_2: '不可大于999999999.99',
    currency_placeholder: '请选择账户属性',
    currency_valid_1: '账户属性必填',
    statistic_time_range: '统计时间范围',
    last: '最近',
    days: '天',
    data_method_placeholder: '请输入',
    data_method_valid_1: '统计时间范围仅可输入正整数且不可大于93',
    current_day_tip: '当天请输入1',
    time_zone_placeholder: '请选择时区',
    time_zone_valid_1: '时区必填',
    shanghai: '上海',
    check_frequency: '检查频次',
    check_frequency_time_placeholder: '请选择要执行的时间（可选择多个时间）',
    check_frequency_time_valid_1: '检查频次必填',
    select_all: '全选',
    deselect_all: '取消全选',
    notification_recipient: '触发通知人',
    email_placeholder: '请输入邮箱，多个用逗号隔开',
    email_valid_1: '触发通知人必填',
    email_valid_2: '请输入正确的邮箱',
    email_valid_3: '最多可添加20个邮箱',
    notification_designated_email_valid_1: '触发通知人必填',
    add: '添加',
    trigger_action:'触发操作',
    adjust_bid: '调整出价',
    closed_status: '关闭状态',
    convert_keywords: '搜索词转关键词',
    convert_nokeywords: '搜索词转否定关键词',
    del_keywords: '删除关键词',
    daily_budget: '更改每日预算',
    total_budget: '更改总预算',
    new_bid: '设置新出价',
    increase_bid: '提高出价',
    decrease_bid: '降低出价',
    amount_of_money_placeholder: '请输入内容',
    by_amount: '按金额',
    by_percentage: '按百分比',
    new_budget: '设置新预算',
    increase_budget: '提高预算',
    decrease_budget: '降低预算',
    


    remove_monitoring: '去除监控',
    off: '关闭',
    off_message: '您确认要关闭吗？关闭后所输入内容不会保存。',
    off_prompt: '提示',
    off_confirm: '确定',
    off_cancel: '取消',
    save: '保存',
};
const EN ={
    total_installs_price: 'TotalAvgCPI',
    search_field_placeholder: 'Please enter search terms, separated by commas',
    search_field_valid_1: 'Please enter search terms',
    search_field_valid_2: 'Cannot input []\\;{}"<> or emojis',
    comparison_type_valid: 'Operator is required',
    metric_monitoring: 'Intelligent management',
    greater_than_or_equal_to : 'Greater than or equal to',
    less_than_or_equal_to : 'Less than or equal to',
    rmb : 'RMB',
    usd : 'USD',
    trigger_condition: 'Trigger Condition',
    comparison_value_placeholder: 'Please enter a positive number',
    comparison_value_valid_1: 'Please enter a positive number, up to two decimal places',
    comparison_value_valid_2: 'Cannot exceed 999999999.99',
    currency_placeholder: 'Please select account attribute',
    currency_valid_1: 'Account attribute is required',
    statistic_time_range: 'Statistic Time Range',
    last: 'Last',
    days: 'days',
    data_method_placeholder: 'Please enter',
    data_method_valid_1: 'Statistic time range must be a positive integer and cannot exceed 93',
    current_day_tip: 'Enter 1 for the current day',
    time_zone_placeholder: 'Please select a time zone',
    time_zone_valid_1: 'Time zone is required',
    shanghai: 'Shanghai',
    check_frequency: 'Check Frequency',
    check_frequency_time_placeholder: 'Please select the execution time (multiple times can be selected)',
    check_frequency_time_valid_1: 'Check frequency is required',
    select_all: 'Select All',
    deselect_all: 'Deselect All',
    notification_recipient: 'Notification Recipient',
    email_placeholder: 'Please enter emails, separated by commas',
    email_valid_1: 'Notification recipient is required',
    email_valid_2: 'Please enter a valid email address',
    email_valid_3: 'Up to 20 email addresses can be added',
    notification_designated_email_valid_1: 'Notification recipient is required',
    add: 'Add',
    trigger_action:'Trigger action',
    adjust_bid: 'Adjust bid',
    closed_status: 'Closed status',
    convert_keywords: 'Convert search term to keyword',
    convert_nokeywords: 'Convert search term to negative keyword',
    del_keywords: 'Delete keyword',
    daily_budget: 'Change daily budget',
    total_budget: 'Change total budget',
    new_bid: 'Set new bid',
    increase_bid: 'Increase bid',
    decrease_bid: 'Decrease bid',
    amount_of_money_placeholder: 'Please enter content',
    by_amount: 'By amount',
    by_percentage: 'By percentage',
    new_budget: 'Set New Budget',
    increase_budget: 'Increase Budget',
    decrease_budget: 'Decrease Budget',



    remove_monitoring: 'Remove Monitoring',
    off: 'Off',
    off_message: 'Are you sure you want to close? Unsaved content will be lost.',
    off_prompt: 'Prompt',
    off_confirm: 'Confirm',
    off_cancel: 'Cancel',
    save: 'Save',
};

export function i18n(language) {
    const data = language ==='EN'? EN : CN;
    function t(field, other) {
        const text = data[field] || CN[field];
        if (text && typeof other !== 'undefined') {
            return text.replace('{}', other)
        }
        return text;
    }
    return { t }
}